/**
 * Règle métier : coordonnées / champs privés côté acheteur.
 * - Litige ouvert → masqué
 * - Dernier litige clos en remboursement (refund) → masqué
 * - RDV confirmé (`fonds_debloques`) sans blocage ci-dessus → visible
 * - Litige clos en faveur du vendeur (`release`, ex. refus acheteur infondé) → visible
 */

export function normTxId(v) {
  return String(v ?? "")
    .trim()
    .toLowerCase();
}

function litigeStatusLower(d) {
  return String(d?.status ?? d?.statut ?? "").trim().toLowerCase();
}

export function isLitigeRowOpen(d) {
  const s = litigeStatusLower(d);
  return s === "open" || s === "in_review";
}

export function isLitigeRowClosed(d) {
  const s = litigeStatusLower(d);
  return s === "closed" || s === "clos" || s === "resolu" || s === "résolu";
}

function pickLatestClosedLitige(litiges) {
  const closed = (litiges || []).filter(isLitigeRowClosed);
  if (!closed.length) return null;
  return [...closed].sort((a, b) => {
    const ta = Date.parse(String(a?.resolved_at || a?.updated_at || a?.created_at || "")) || 0;
    const tb = Date.parse(String(b?.resolved_at || b?.updated_at || b?.created_at || "")) || 0;
    return tb - ta;
  })[0];
}

/**
 * @param {object|null} tx — ligne transaction (ex. depuis /transactions/mine)
 * @param {object[]} litigesForTx — litiges dont transaction_id correspond à cette transaction
 */
export function buyerPrivateUnlocked(tx, litigesForTx) {
  if (!tx) return false;
  const list = Array.isArray(litigesForTx) ? litigesForTx : [];
  if (list.some(isLitigeRowOpen)) return false;

  const latest = pickLatestClosedLitige(list);
  if (latest) {
    const dec = String(latest.admin_decision || "").trim().toLowerCase();
    if (dec === "refund") return false;
    if (dec === "release") return true;
  }

  const st = String(tx.statut || "").toLowerCase();
  return st === "fonds_debloques";
}
